import { Grid } from '@mui/material';

import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SavePaymentMethod } from '../../shared/components';

export type CreatePaymentMethodPageProps = {};

const CreatePaymentMethodPage: React.FC<CreatePaymentMethodPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_formapago);

  return (
    <Grid container spacing={2} padding="24px">
      <SavePaymentMethod titlePage="Crear Método de Pago" />
    </Grid>
  );
};

export default CreatePaymentMethodPage;
